import React from "react";

const StakeholderEngagementTable = ({
  stakeholderdata,
  setStakeholderData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...stakeholderdata];
    updated[index][field] = value;
    setStakeholderData(updated);
  };

  const addRow = () => {
    setStakeholderData([
      ...stakeholderdata,
      {
        stakeholderGroup: "",
        isMarginalized: "",
        communicationChannels: "",
        frequency: "",
        purpose: "",
      },
    ]);
  };

  const removeRow = () => {
    if (stakeholderdata.length > 1) {
      setStakeholderData(stakeholderdata.slice(0, -1));
    }
  };

  return (
    <div>
      <div
        style={{
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
              <th style={headerStyle}>Stakeholder Group</th>
              <th style={headerStyle}>
                Whether identified as vulnerable & Marginalized group (Yes/No)
              </th>
              <th style={headerStyle}>
                Channels of communication (E-mail, SMS, Pamphlets, Newspaper,
                advertisement, Community meetings, Notice board, Website, other)
              </th>
              <th style={headerStyle}>
                Frequency of engagement (Annually/half-yearly/Quarterly/Others)
              </th>
              <th style={headerStyle}>
                Purpose and scope of engagement including key topics and
                concerns raised during such engagements
              </th>
            </tr>
          </thead>
          <tbody>
            {stakeholderdata.map((row, idx) => (
              <tr key={idx}>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Enter Details"
                    value={row.stakeholderGroup}
                    onChange={(e) =>
                      handleChange(idx, "stakeholderGroup", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Yes/ No"
                    value={row.isMarginalized}
                    onChange={(e) =>
                      handleChange(idx, "isMarginalized", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Enter Details"
                    value={row.communicationChannels}
                    onChange={(e) =>
                      handleChange(idx, "communicationChannels", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Enter Details"
                    value={row.frequency}
                    onChange={(e) =>
                      handleChange(idx, "frequency", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Enter Details"
                    value={row.purpose}
                    onChange={(e) =>
                      handleChange(idx, "purpose", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        {stakeholderdata.length > 1 && (
          <button onClick={removeRow} style={removeBtn}>
            - Remove
          </button>
        )}
        <button onClick={addRow} style={addBtn}>
          + Add More
        </button>
      </div>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "20%",
  wordWrap: "break-word",
};

const cellStyle = {
  padding: "15px",
  border: "1px solid #000",
  textAlign: "center",
  width: "20%",
};

const inputStyle = {
  width: "100%",
  padding: "15px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
  boxSizing: "border-box",
};

const addBtn = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeBtn = { ...addBtn };

export default StakeholderEngagementTable;
